import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../../admin_resources/css/admin_layout.css";
import "../../../admin_resources/css/admin_common.css";
import "../../../admin_resources/css/admin_style.css";
import ADMIN_HEADER from "../Admin_Header";
import axios from "axios";

const Admin_Franchise_write = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const [permissions, setPermissions] = useState({});
  
  useEffect(() => {
	const titleElement = document.getElementsByTagName("title")[0];
	titleElement.innerHTML = `아소비 관리자 페이지`;
	
    // 관리자 권한 정보 가져오기
    const adminId = localStorage.getItem("adminId");
    if (adminId) {
      fetchPermissions(adminId);
    }
  }, []);

  const fetchPermissions = async (adminId) => {
    try {
      const response = await fetch(`/permissions/${adminId}`); // 권한 확인 API 호출
      const data = await response.json();
      setPermissions(data); // 권한 정보를 상태로 설정
    } catch (error) {
      console.error("권한 정보를 가져오는 데 실패했습니다.", error);
    }
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      alert("파일을 선택해 주세요");
      return; // 파일 미선택 시 제출 중단
    }

    const isConfirmed = window.confirm("등록하시겠습니까?");
    if (!isConfirmed) {
      return; // 사용자가 취소를 선택하면 제출 중단
    }

    const formData = new FormData();
    formData.append("regId", localStorage.getItem("adminId"));
    formData.append("inputExcelFile", file);

    try {
      setLoading(true);
      const response = await axios.post("/fruploadExcel", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {
        const savedDataList = response.data;
        sessionStorage.setItem("fridxList", JSON.stringify(savedDataList));

        alert("업로드에 성공하였습니다. 좌표를 업데이트 해주세요.");
        window.location.href = "/admin/form/franchise_map_up";
      } else {
        alert("업로드에 실패하였습니다. 엑셀 파일을 다시 확인해주세요.");
      }
    } catch (error) {
      console.error("Error uploading schedule:", error);
      alert("업로드에 실패하였습니다. 엑셀 파일을 다시 확인해주세요.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <ADMIN_HEADER />
      <div className="admin_write">
        <div className="path-sec">
          HOME &gt; <span className="menu1">데이터 관리</span> &gt;
          <span className="menu2"> 가맹점 관리</span>
        </div>
        <table>
          <tr>
            <td>
              <div className="sec-snb">
                <h3 className="snb_tit">데이터 관리</h3>
                <ul className="snb_list">
				{permissions.ent && (
				  <li>
				    <a href="/admin/form/ent">입회신청 관리</a>
				  </li>
				)}
				{permissions.fr && (
				  <li>
				    <a href="/admin/form/fr">창업신청 관리</a>
				  </li>
				)}
				{permissions.franchise && (
				  <li className="cur">
				    <a href="/admin/form/franchise">가맹점 관리</a>
				  </li>
				)}
				{permissions.schedule && (
				  <li>
				    <a href="/admin/form/schedule">창업일정 관리</a>
				  </li>
				)}
				{permissions.jisa && (
				  <li>
				    <a href="/admin/form/jisa">지사장 지원 관리</a>
				  </li>
				)}
				{permissions.q && (
				  <li>
				    <a href="/admin/form/q">앱 문의 관리</a>
				  </li>
				)}
				{permissions.etc_q && (
				  <li>
				    <a href="/admin/form/etc_q">기타문의 관리</a>
				  </li>
				)}
                  {(localStorage.getItem("adminId") === "jiwoo" ||
                    localStorage.getItem("adminId") === "nixona" ||
                    localStorage.getItem("adminId") === "wjdrnr90" ||
                    localStorage.getItem("adminId") === "hyoseon.jang") && (
                    <li>
                      <a href="/admin/form/point">적립금 정산 관리</a>
                    </li>
                  )}
                </ul>
              </div>
            </td>
            <td>
              <div className="bx-top">가맹점 등록</div>
              <form id="writeform" onSubmit={handleSubmit}>
                <div className="tb_01 wr">
                  <table>
                    <tbody>
                      <tr>
                        <th>첨부파일</th>
                        <td>
                          <label className="file">
                            <input
                              id="inputExcelFile"
                              name="inputExcelFile"
                              type="file"
                              className="inputtext"
                              onChange={handleFileChange}
                            />
                            <p className="ps">
                              ※ 업로드 후 좌표 업데이트를 해주세요!
                            </p>
                          </label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="view-btn">
                    <span className="btn custom_s">
                      <button>
                        <Link
                          to="/admin/form/schedule"
                          style={{ color: "#fff" }}
                        >
                          목록
                        </Link>
                      </button>
                    </span>

                    <div className="btn-right">
                      <span className="btn custom_r">
                        <button
                          type="submit"
                          className="submit-btn"
                          disabled={loading}
                        >
                          {loading ? "Uploading..." : "등록"}
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
              </form>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default Admin_Franchise_write;
